export default __webpack_public_path__ + "pages/slides-18d2281c71b88d4ef641651951fce97f.html";